<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Consulta De Datos Para La Facturas Electrónicas
        </v-card-title>
        <v-card-text>
            <v-container fluid grid-list-xl>
                <v-row dense>
                    <v-col cols="12" sm="3">
                        <v-autocomplete label="Tipo de Movimiento *" color="textbox" v-model="obForm.idTipoMovimiento"
                            :items="listaGeneral.listTipoMovimiento" item-text="movimiento"
                            item-value="idTipoMovimiento" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-autocomplete label="Póliza *" color="textbox" v-model="obForm.idPoliza"
                            :items="listaGeneral.listPoliza" item-text="poliza" item-value="id_poliza" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-text-field label="N° Certificado *" color="textbox" v-model="obForm.idCertificado" dense
                            outlined :rules="numeroRegla" />
                    </v-col>
                    <v-col cols="12" sm="3" class="text-right">
                        <v-tooltip right color="primary">
                            <template v-slot:activator="{ on }">
                                <v-btn outlined color="primary" @click="onListarDatos" v-on="on" :disabled="disabled">
                                    Buscar<v-icon>search</v-icon>
                                </v-btn>
                            </template>
                            <span>Buscar</span>
                        </v-tooltip>
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col cols="12">
                        <v-row dense>
                            <v-col cols="12" sm="12">
                                <p class="title" v-html="title"></p>
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Cédula o Ruc" color="textbox" v-model="obForm.nroDocumento" dense
                                    outlined readonly />
                            </v-col>
                            <v-col cols="12" sm="8">
                                <v-text-field label="Nombre o Razón Social" color="textbox" v-model="obForm.nombre"
                                    dense outlined readonly />
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field label="Teléfono" color="textbox" v-model="obForm.telefono" dense outlined
                                    readonly />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field label="Email" color="textbox" v-model="obForm.email" dense outlined
                                    readonly />
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="12">
                                <v-text-field label="Dirección" color="textbox" v-model="obForm.direccion" dense
                                    outlined readonly />
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="12">
                                <p class="title" v-html="'Datos de Póliza'"></p>
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Póliza" color="textbox" v-model="obForm.poliza" dense outlined
                                    readonly />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Fecha de Emisión" color="textbox" v-model="obForm.fechaEmision" dense outlined
                                    readonly />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field label="N° Certificado" color="textbox" v-model="obForm.idCertificado" dense outlined
                                    readonly />
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Fecha Vigencia Desde" color="textbox" v-model="obForm.fechaVigenciaDesde" dense outlined
                                    readonly />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Fecha Vigencia Hasta" color="textbox" v-model="obForm.fechaVigenciaHasta" dense outlined
                                    readonly />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Broker" color="textbox" v-model="obForm.broker" dense outlined
                                    readonly />
                            </v-col>
                        </v-row>

                        
                        <v-row dense>
                            <v-col cols="12" sm="12">
                                <p class="title" v-html="'Valor de Impuesto y Prima a Facturar '"></p>
                            </v-col>
                        </v-row>

                        <v-row dense align="start" justify="start">
                            <v-col cols="12" sm="3">
                                <v-text-field label="Prima Bruta" color="textbox" v-model="obForm.primaBruta" dense outlined
                                    readonly />
                            </v-col>
                        </v-row>

                        <v-row dense align="start" justify="start">
                            <v-col cols="12" sm="3">
                                <v-text-field label="Impuesto SCVS" color="textbox" v-model="obForm.impuestoScvs" dense outlined
                                    readonly />
                            </v-col>
                        </v-row>

                        <v-row dense align="start" justify="start">
                            <v-col cols="12" sm="3">
                                <v-text-field label="Impuesto SSC" color="textbox" v-model="obForm.impuestoSsc" dense outlined
                                    readonly />
                            </v-col>
                        </v-row>

                        <v-row dense align="start" justify="start">
                            <v-col cols="12" sm="3">
                                <v-text-field label="Impuesto IVA" color="textbox" v-model="obForm.impuestoIva" dense outlined
                                    readonly />
                            </v-col>
                        </v-row>

                        <v-row dense align="start" justify="start">
                            <v-col cols="12" sm="3">
                                <v-text-field label="Derecho Emisión" color="textbox" v-model="obForm.derechoEmision" dense outlined
                                    readonly />
                            </v-col>
                        </v-row>

                        <v-row dense align="start" justify="start">
                            <v-col cols="12" sm="3">
                                <v-text-field label="Prima Neta" color="textbox" v-model="obForm.primaNeta" dense outlined
                                    readonly />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: 'ConsultaDatosFacturarView',
        data: () => ({
            listaGeneral: {},
            parametros: {},
            obForm: {
                idTipoMovimiento: null,
                idPoliza: null,
                idCertificado: null,
                idEstado: null
            },
            disabled: false
        }),
        created() {
            var error = 'E';
            axios.post(`${BASE_URI}administrador/consulta-datos-facturar/cargaGeneral`)
                .then((r) => {
                    if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                    if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion); }
                    this.$set(this, 'listaGeneral', r.data.data.listas);
                    this.$set(this, 'parametros', r.data.data.parametros);
                    this.obForm.idTipoMovimiento = _.get(this.listaGeneral, ['listTipoMovimiento', '0','idTipoMovimiento'], null);
                    this.obForm.idPoliza = _.get(this.listaGeneral, ['listPoliza', '0', 'id_poliza'], null);
                    this.obForm.idEstado = _.get(this.parametros, 'idEstadoDefault', null);
                })
                .catch((e) => {
                    mensajesAlerta(e, error);
                });
        },
        computed: {
            title() {
                return `Yo, ${_.get(this.obForm,'nombreCliente','N/A')} autorizo que la factura se la realice con los datos aquí mencionados`;
            }
        },
        methods: {
            onListarDatos(e) {
                if (!_.isUndefined(e)) {
                    try {
                        var error = 'E';
                        if(_.size(this.obForm.idCertificado) == 0) throw 'Debe escribir el número del certificado.';
                            this.obForm = _.pick(this.obForm,['idTipoMovimiento','idPoliza','idCertificado','idEstado']);

                            var o = _.merge({opcion:'LISTAR'},
                                            _.pick(this.obForm,['idTipoMovimiento','idPoliza','idCertificado','idEstado'])
                                            );
        
                            axios.post(`${BASE_URI}administrador/consulta-datos-facturar/listar`,o)
                                .then((r)=>{
                                    if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                                    if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion); }
                                        this.obForm = _.merge({},this.obForm,r.data.data[0]);
                                })
                                .catch((e) => {
                                    mensajesAlerta(e, error);
                                });
                    } catch (ex) {
                         mensajesAlerta(ex, error);
                    }
                }
            }
        }
    }
</script>